// Centralized configuration from environment variables with defaults

const config = {
  // Branding
  appName: import.meta.env.VITE_APP_NAME || 'AClients',

  // Domain Configuration
  baseDomain: import.meta.env.VITE_BASE_DOMAIN || 'avcms.ru',
  altDomain: import.meta.env.VITE_ALT_DOMAIN || 'aclients.ru',
  cdnCname: import.meta.env.VITE_CDN_CNAME || '730806c97ac3af2d.topology.gslb.yccdn.ru',
  proxyIp: import.meta.env.VITE_PROXY_IP || '194.87.102.121',

  // App URL
  appUrl: import.meta.env.VITE_APP_URL || 'https://rent-space-landing-prod.web.app',
};

export default config;
